import React, { useEffect } from 'react';
import { setLatestActivityTime } from '../../../types/accessControl/AccessControlConstants';

export const ActivityTracker: React.FC = () => {
  useEffect(() => {
    const activityEvents = ['keydown', 'click', 'scroll', 'mousemove'];
    const handleUserActivity = () => {
      setLatestActivityTime();
    };

    activityEvents.forEach((eventName) => window.addEventListener(eventName, handleUserActivity));
    return () => {
      activityEvents.forEach((eventName) => window.removeEventListener(eventName, handleUserActivity));
    };
  }, []);

  return null;
};
